import React, { FunctionComponent, useState } from 'react';
import { Shipping } from '../icons/Shipping';
import { DeliveryMode } from "@/models/scope/productSheet/mkpAvailability/DeliveryMode";
import {dispatchProductSheetMoreShippingHandleClick} from "@/animations/responsive/productPageTracking";
interface Props {
    allowedDeliveryModes: DeliveryMode[],
    isLayer: boolean,
}

const MkpAvailability: FunctionComponent<Props> = ({ allowedDeliveryModes, isLayer }) => {
    const [displayMore, setDisplayMore] = useState(false);
    const handleClick = () => {
        setDisplayMore(true);
        dispatchProductSheetMoreShippingHandleClick( "Clic plus infos livraison FP");
    }

    if (!allowedDeliveryModes) {
        return null;
    }
    const renderDeliveryBlock = (deliveryMode: DeliveryMode, index: number) => {

        const {
            label, cost, earliestDate, latestDate, code
        } = deliveryMode || {};
        if (!displayMore && index > 1) return null;
        return (
            <div className='delivery-block' key={`${code}_${index}`}>
                <div className='header'>
                    <div className='titleContainer'>
                        <Shipping />
                        <p className='title'>Livraison</p>
                    </div>
                    <p className='cost'>
                        {(cost !== undefined && parseInt(cost) !== 0) ? `${cost.replace('.', ',')} €` : 'Gratuit'}
                    </p>
                </div>
                <p className='label'>{label}</p>
                {!isLayer ? (
                    <p className='date'>{`Entre le ${earliestDate} et le ${latestDate}`}</p>
                ) : (
                    <ul>
                        <li className='date'>{`Entre le ${earliestDate} et le ${latestDate}`}</li>
                    </ul>
                )}
            </div>
        );
    };

    return (
        <div className='mkp-availability'>
            {!isLayer && (
                <div className='mkp-pickup layout-bloc'>
                    Produit disponible uniquement en livraison
                </div>
            )}
            {allowedDeliveryModes.map((deliveryMode, index) =>
                renderDeliveryBlock(deliveryMode, index),
            )}
            {allowedDeliveryModes?.length > 2 && !displayMore && (
                <div
                    onClick={() => handleClick()}
                    className={`mkp-pickup layout-bloc button-more ${isLayer ? 'isLayer' : ''
                        }`}
                >
                    <p>Voir plus d'options de livraison</p>
                    <img src={"/assets/images/responsive/icons/chevron-down.svg"} alt='chevron' />
                </div>
            )}
        </div>
    );
};
export default MkpAvailability;